import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  smartphone: {
    position: 'relative',
    width: '275px',
    height: '580px',
    margin: 'auto',
    border: '12px black solid',

    borderRadius: '50px',
    fontSize: '0.7rem',
    background: '#fff',
    overflow: 'hidden',
    boxShadow: '10px 10px 10px rgba(0,0,0,0.2)',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: '10',
      top: '5px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#000',
      borderRadius: '20px',
      width: '80px',
      height: '20px'
    }
  },
  content: {
    height: '557px',
    objectFit: 'contain',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: '100',
      bottom: '4px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: '#555555',
      borderRadius: '20px',
      width: '100px',
      height: '3.5px'
    }
  },
  contentBoby: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    height: '100%',
    '& img': {
      objectFit: 'contain',
      height: 'auto'
    },
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      width: 0
    }
  },
  iframe: {
    width: '100%',
    border: 'none',
    height: '100%'
  }
}))

const MobilePreview = ({ children }) => {
  const classes = useStyles()

  return (
    <div className={classes.smartphone}>
      <div className={classes.content}>
        <div className={classes.contentBoby}>{children}</div>
      </div>
    </div>
  )
}

export default MobilePreview
